import createAPIRequestId from '../helpers/createAPIRequestId'
import store from '../store/index'
//----------------------
// edit character skill
//----------------------
export default async function useEditCharacterSkill(skill, { preview = false } = {}) {
  console.log('-------------------------------------')
  console.log('IN useEditCharacterSkill....')
  console.log('skill:', skill)
  //--------------
  // access store
  //--------------
  const this_store = store
  //--------------------
  // set api call parms
  //--------------------
  let parm_id = ''
  let parm_partialInd = false

  // only treat id as present when it's a real (non-temp) value
  if (skill.id !== undefined && skill.id !== null && skill.id !== '') {
    parm_id = skill.id
    parm_partialInd = skill.action !== 'DELETE' ? true : false
  }
  //----------------------------------------
  // guard: UPDATE/DELETE must have an id
  //----------------------------------------
  if (
    (skill.action === 'UPDATE' || skill.action === 'DELETE') &&
    (parm_id === '' || parm_id === null || parm_id === undefined)
  ) {
    console.error(
      'useEditCharacterSkill: missing character_skill id for action',
      skill.action,
      'skill =',
      skill,
    )
    throw new Error('Missing character_skill id for ' + skill.action + ' in useEditCharacterSkill')
  }
  //---------------------------------------------
  // declare request parms to create api request
  //--------------------------------------------
  let endpoint = 'api/v1/character-skills/'
  //
  let request_parms = {
    endpoint: preview ? endpoint + '?preview=true' : endpoint,
    partialInd: parm_partialInd,
    id: parm_id,
  }
  //---------------------------------------------------
  // where DELETE add indicator for create api request
  //---------------------------------------------------
  if (skill.action === 'DELETE') {
    request_parms.deleteInd = true
  }
  //--------------------------
  // create api request by id
  //--------------------------
  let request = createAPIRequestId(request_parms)
  //---------------
  // set api parms
  //---------------
  let api_parms = {
    api_request: request,
    api_preview: preview,
  }
  //----------------------------------
  // include payload where not DELETE
  //----------------------------------
  if (skill.action !== 'DELETE') {
    api_parms.payload = skill.payload
  }
  console.log('api_parms = ', api_parms)
  //-------------------------------------------------------------------------
  // - return the dispatch Promise in all cases
  // - preview callers will await this and receive the response
  // - non-preview callers can ignore the returned Promise (fire-and-forget)
  //-------------------------------------------------------------------------
  return this_store
    .dispatch('characters/editCharacterSkill', api_parms)
    .then((res) => {
      // optional: log preview response
      if (preview) console.log('useEditCharacterSkill preview result:', res)
      return res
    })
    .catch((err) => {
      if (err?.response?.status === 404 && skill.action === 'DELETE') {
        console.warn(
          'CharacterSkill already deleted; treating DELETE as successful for skill =',
          skill.name,
        )

        return {
          data: null,
          status: 204,
          statusText: 'No Content',
        }
      }

      console.error('editCharacterSkill error:', err)
      // rethrow so callers awaiting this will receive the rejection
      throw err
    })
}
